<template>
    <div v-if="user" class="p-3">
        <b-card
            title="Konfigurasi Master Loket"
        >
            <b-card-text>
                <b-button variant="primary" class="btn-sm" @click="addMasterLoket"><b-icon icon="plus"></b-icon> Tambah Data</b-button>

                <div id="tabledata-master-loket" class="mt-3"></div>

                <div v-if="table" class="row mt-5">
                    <div class="col">
                        Showing {{ paging_data.from }} to {{ paging_data.to }} of {{ paging_data.total }} entries
                    </div>
                    <div class="col">
                        <b-pagination
                            v-if="total_rows > 0"
                            v-model="page"
                            :per-page="item_per_page"
                            :total-rows="total_rows"
                            @page-click="pageClick"
                            prev-text="Prev"
                            next-text="Next"
                            align="center"
                        >
                        </b-pagination>
                    </div>
                </div>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            table: null,
            table_data: [],
            user: null,
            access_token: null,
            item_per_page: 10,
            total_rows: 0,
            page: 1,
            tabulator_options: {},
            table: null,
            paging_data: {
                from: 0,
                to: 0,
                total: 0
            },
        }
    },
    created() {
        this.getAuth()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')
            this.access_token = localStorage.getItem('access_token')

            this.getMasterLoket()
        },
        addMasterLoket() {
            this.$router.push({ name: 'add-master-loket' }).catch(()=>{})
        },
        getMasterLoket() {
            this.$isLoading(true)
            let query_page = this.page ? '&page=' + this.page : ''
            let uri = '/api/konf_master_loket?per_page=' + this.item_per_page + query_page

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                this.table_data = response.data.master_lokets.data
                this.total_rows = response.data.master_lokets.total
                this.paging_data = {
                    from: response.data.master_lokets.from,
                    to: response.data.master_lokets.to,
                    total: response.data.master_lokets.total
                }

                let actions = function (cell, formatterParams) {
                    return '<button id="edit" class="btn btn-warning btn-sm"><i id="edit" class="fa fa-pencil" aria-hidden="true"></i> edit</button>&nbsp;&nbsp;<button id="delete" class="btn btn-danger btn-sm"><i id="delete" class="fa fa-trash" aria-hidden="true"></i> delete</button>'
                }

                this.table = new Tabulator('#tabledata-master-loket', {
                    layout:"fitColumns",
                    data: this.table_data,
                    paginationSize: this.item_per_page,
                    height:"100%",
                    columns: [
                        {title: 'Kategori', field: 'kategori.nama', headerSort: false},
                        {title: 'Nama', field: 'nama', headerSort: false},
                        {title: 'Aksi', field: 'aksi', formatter: actions, headerSort: false, cellClick: this.actionButton}
                    ]
                })

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        actionButton(e, cell) {
            let data = cell.getRow().getData()
            let type = e.target.id
            if (type == 'edit') {
                this.$router.push({ name: 'edit-master-loket', params: {id: data.id} }).catch(()=>{})
            } else if (type == 'delete') {
                this.$swal.fire({
                    title: 'Perhatian! ',
                    text: 'Data akan dihapus. Yakin?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, hapus!',
                    cancelButtonText: 'Batal'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.deleteMasterLoket(data.id)
                    }
                }).catch((error) => {
                    let response = error.response != undefined ? error.response : null
                    if (response) {
                        if (response.status == 401) {
                            localStorage.setItem('access_token', '')
                            localStorage.setItem('user', '')
                            location.href = '/login'
                        }
                    }
                })
            }
        },
        deleteMasterLoket(id) {
            this.$isLoading(true)
            let uri = '/api/konf_master_loket/' + id

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.delete(uri, headers).then(response => {
                if (response.data.status == 'success') {
                    this.getMasterLoket()
                } else {
                    this.$isLoading(false)
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        pageClick(bEvent, page) {
            this.page = page
            this.getMasterLoket()
        },
    }
}
</script>
